import { useContextBridge } from "@react-three/drei";
import { Canvas } from "@react-three/fiber"

import AppContext from "../hooks/AppConext"
import { Complex } from "./Complex"
import { FX } from "./FX"
import { ConnectEvents } from "./Helpers/ConnectedEvents"
import { Lights } from "./Lights"

export const Scene = () => {
  const ContextBridge = useContextBridge(AppContext)

  return (
    <Canvas shadows flat orthographic camera={{ position: [14, 11, 32] }}>
      <ContextBridge>
        <Lights />
        <Complex />
        <FX />
        <ConnectEvents />
      </ContextBridge>
    </Canvas>
  )
}
